export const CREATOR_TAX_DECLARATION_UPDATED_EVENT = "creator-tax-declaration:updated";

export const notifyCreatorTaxDeclarationUpdated = (): void => {
	window.dispatchEvent(new Event(CREATOR_TAX_DECLARATION_UPDATED_EVENT));
};
